import {
	Scene,
	Engine,
	Mesh,
	AbstractMesh,
	Light,
	Camera,
	PickingInfo,
	Observable,
} from '@babylonjs/core';

export default class ObservablesManager {
	/**
	 * On scene initialization.
	 */
	public onSceneInitObservable: Observable<Scene>;
	/**
	 * On engine initialization.
	 */
	public onEngineInitObservable: Observable<Engine>;
	/**
	 * On mesh creation.
	 */
	public onMeshCreatedObservable: Observable<Mesh>;
	/**
	 * On light creation.
	 */
	public onLightCreatedObservable: Observable<Light>;
	/**
	 * On camera creation.
	 */
	public onCameraCreatedObservable: Observable<Camera>;

	/**
	 * Camera view or projection have changed.
	 */
	public onCameraViewUpdated: Observable<Camera>;

	/**
	 * On pointer Pick.
	 */
	public onPointerPickObservable: Observable<PickingInfo>;

	/**
	 * On collision.
	 */
	public onCollisionObservable: Observable<[AbstractMesh, AbstractMesh[]]>;

	/**
	 * On collision end.
	 */
	public onCollisionEndObservable: Observable<AbstractMesh>;

	constructor() {
		this.onSceneInitObservable = new Observable();
		this.onEngineInitObservable = new Observable();
		this.onMeshCreatedObservable = new Observable();
		this.onPointerPickObservable = new Observable();
		this.onCollisionObservable = new Observable();
		this.onCollisionEndObservable = new Observable();
		this.onCameraViewUpdated = new Observable();
	}

	/**
	 * Destroy.
	 */
	public destroy(): void {
		this.onSceneInitObservable.clear();
		this.onEngineInitObservable.clear();
		this.onMeshCreatedObservable.clear();
		this.onPointerPickObservable.clear();
		this.onCollisionObservable.clear();
	}
}
